/* eslint-disable complexity */
// These are the events to GTM
import { useRouter } from 'next/router'
import { useCallback, useMemo } from 'react'
import { useUserRQInfo } from '../../components/Common/user-provider/user-provider'
import { LOB } from '../../utils/common/web/gtm-events/eventsList'
import { TGtmEventParameter } from '../../utils/common/web/gtm-events/types'

export const getLineOfBusiness = (url?: string) => {
  const lowerCaseUrl = url?.toLowerCase()
  if (
    lowerCaseUrl?.includes('mutual-fund') ||
    lowerCaseUrl?.includes('mf/explore/') ||
    url === LOB.MUTUAL_FUNDS
  ) {
    return LOB.MUTUAL_FUNDS
  } else if (
    // this if else HAS to be kept before us-stock check below because
    // remittance screens also has /us-stocks/ as a prefix in them and
    // they don't have a pathname identifier of their own. Hence relying
    // solely on `url` argument being LOB.REMITTANCE
    url === LOB.REMITTANCE
  ) {
    return LOB.REMITTANCE
  } else if (
    lowerCaseUrl?.includes('us-stock') ||
    lowerCaseUrl?.includes('forex')
  ) {
    return LOB.US_STOCKS
  } else if (lowerCaseUrl?.includes('/stocks')) return LOB.IN_STOCKS
  else if (lowerCaseUrl?.includes('goal')) return LOB.GOALS
  else if (lowerCaseUrl?.includes('subscription')) return LOB.SUBSCRIPTIONS
  else if (lowerCaseUrl?.includes('advisory')) return LOB.NOTIFICATIONS
  else if (lowerCaseUrl?.includes('article')) return LOB.BLOGS
  else if (lowerCaseUrl?.includes('dashboard')) return LOB.DASHBOARD
  else if (url === LOB.HOMEPAGE) return LOB.HOMEPAGE
  else if (url === '/') return LOB.HOMEPAGE
  else if (lowerCaseUrl?.includes('kyc')) return LOB.KYC
  else if (lowerCaseUrl?.includes('learn')) return LOB.LEARN
  else if (lowerCaseUrl?.includes('fixed-deposit')) return LOB.FD
  else if (lowerCaseUrl?.includes('features')) return LOB.FEATURES
  else if (lowerCaseUrl?.includes('calculators')) return LOB.CALCULATORS
  else if (lowerCaseUrl?.includes('/p/')) return LOB.GUIDES
  else if (lowerCaseUrl?.includes('insurance')) return LOB.INSURANCE
  else return LOB.OTHERS
}

export default function useGtmEvent() {
  const { isAuthenticated, userBasicRQData } = useUserRQInfo()
  const { data: { id, is_subscribed, subscription_plan, boVerified } = {} } =
    userBasicRQData

  const router = useRouter()

  const userParameters = useMemo(() => {
    return {
      user_status: isAuthenticated ? 'logged_in' : 'non_logged_in', // Indicates whether user is logged in or not
      userid: id, // user's unique id
      is_prime_member: is_subscribed ? 'yes' : 'no', // whether user is subscribed or not
      subscriber: subscription_plan, // plan for user subscription
      profile_verified: boVerified ? 'yes' : 'no',
    }
  }, [id, isAuthenticated, is_subscribed, subscription_plan, boVerified])

  const gtmEventPush = useCallback(
    (data: TGtmEventParameter) => {
      if (typeof window === 'undefined') {
        return
      }

      const {
        eventName,
        headerClickText,
        source,
        lob,
        paymentParams,
        allPageParams,
        mfEventParameter,
      } = data

      // Events name should be in lowercase with underscore separated
      const event = `${eventName.toLowerCase()}`.replace(/ /g, '_')
      const eventParameters = {
        ...paymentParams,
        ...allPageParams,
        ...mfEventParameter,
        event,
        header_click_text: headerClickText,
        source: getLineOfBusiness(source ?? router.asPath),
        lob: getLineOfBusiness(lob),
      }
      const eventPayload = { ...eventParameters, ...userParameters }

      if (process.env.NODE_ENV === 'development') {
        console.info({ eventPayload }, 'GTM Event')
        // return
      }
      //ga4
      // window.dataLayer = window.dataLayer ?? []
      // window.dataLayer.push(eventPayload)
    },
    [router, userParameters],
  )

  return gtmEventPush
}
